import React, {Component} from 'react'
import PropTypes from 'prop-types'
import theme from '../../theme'

// Material components
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import SidebarItem from "../Sidebar/SidebarItem/SidebarItem";
import {t} from 'i18next'
import {Trans} from 'react-i18next'

const confirmValue = 'DELETE';




/**
 * component for sidebar
 * @param classes
 * @returns {*}
 */
class AccountDeletion extends Component {

    constructor(props) {
        super(props);

        this.state = {
            confirmText: '',
            errorMsg: ''
        }
    }

    onSubmitDelete = () => {
        const { confirmText } = this.state;

        if(confirmText === confirmValue) {
            this.props.onRequestDeletion(
                () => {
                    this.props.onSuccess();
                },
                (error) => {
                    if(error.msg) {
                        this.setState({errorMsg: error.msg})
                    }
                });
        }
    };

    render() {
        const { classes } = this.props;
        const { confirmText, errorMsg } = this.state;

        return (
            <SidebarItem>
                <Typography style={styles.textStyle} color='error'>
                <Trans i18nKey="DeviceInformation.sidebar_header_dialog_user_deletion_caution"/>
                </Typography>
                <Typography style={{...styles.textStyle, marginBottom: 20}}>
                   <Trans i18nKey="User.sidebartext_caution_delete_01"/>
                </Typography>
                <Typography style={styles.textStyle}>
                <Trans i18nKey="User.sidebartext_caution_delete_02"/>
                </Typography>
                <div style={styles.inputContainer}>
                    <TextField
                        InputProps={{
                            classes: {
                                underline: styles.textFieldUnerline
                            },
                        }}
                        InputLabelProps={{
                            FormLabelClasses: {
                                root: styles.textFieldFormLabel,
                                focused: styles.textFieldFocused,
                            },
                        }}
                        variant={'standard'}
                        label={t('User.label_confirm_deletion')}
                        value={confirmText}
                        margin="normal"
                        style={{...styles.textField, width: '100%'}}
                        required
                        error={errorMsg.length > 0}
                        helperText={errorMsg.length > 0 ? errorMsg : t('User.helpertext_account_deletion')}
                        onChange={ (e) => this.setState({confirmText: e.target.value})}
                    />
                    <Button variant="outlined"
                            disabled={confirmText !== confirmValue}
                            style={{...styles.sendButton, color: theme.palette.primary.dark, borderColor: theme.palette.primary.dark, marginTop: 20 }}
                            onClick={this.onSubmitDelete}
                            // color="primary"
                            >
                            <Trans i18nKey="User.button_delete_account"/>
                            </Button>
                </div>
            </SidebarItem>
        )
    }
}

const styles = {
    textStyle: {
        fontWeight: 600,
        lineHeight: 2,
        color: theme.palette.error.dark,
    },
    inputContainer: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        display: 'flex',
        flex: 1
    },
    textFieldFormLabel: {
        '&$textFieldFocused': {
            color: theme.palette.primary.dark,
        },
    },
    textFieldFocused: {},
    textFieldUnerline: {
        '&:after': {
            borderBottomColor: theme.palette.primary.dark,
        },
    },
};

AccountDeletion.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    onRequestDeletion: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired
}

export default AccountDeletion
